import React from 'react';
import ReactDOM from 'react-dom';

class QuizIntro extends React.Component{

	render(){
		return (<div className="quiz-intro-message">
					<h1>You are the interviewer</h1>
					<p>Pick a question, listen carefully and give the right answer to get the chance to win a special prize!</p>
					<button onClick={this.props.disableQuizIntro}>Start your interview</button>
				</div>);

	}
}

export default QuizIntro;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/quiz-intro.js